import React from 'react';
import { FaCode, FaLifeRing, FaServer } from 'react-icons/fa';

const Services = () => {
  return (
    <section id="leistungen" className="section">
      <div className="container">
        <h2 className="section-title">Was ich für Sie tun kann</h2>
        <div className="services-grid">
          
          <div className="service-card">
            <div className="service-icon"><FaCode/></div>
            <h3>Webdesign & Entwicklung</h3>
            <p>Von der ersten Idee bis zur finalen Webseite. Ich gestalte und entwickle moderne, responsive Webseiten, die auf Ihre Ziele zugeschnitten sind.</p>
          </div>
          
          <div className="service-card">
            <div className="service-icon"><FaLifeRing/></div>
            <h3>Technischer Support</h3>
            <p>Auch nach dem Launch bin ich für Sie da. Ich biete laufende Wartung und Support, damit Ihre Seite sicher und aktuell bleibt.</p>
          </div>
          
          <div className="service-card">
            <div className="service-icon"><FaServer/></div>
            <h3>Hosting & Domain</h3>
            <p>Keine Lust auf Technik? Gegen einen Aufpreis übernehme ich das komplette Hosting und die Verwaltung Ihrer Domain für Sie.</p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Services;